export default "__VITE_ASSET__m8jG5lm0__"